import { OrgTreeHelper } from '../../../../backend/features/organizations/OrganizationTreeHelper';
import { getOrgChildrenIdsByParentIdFunctionDef } from '../../../../backend/features/organizations/shared';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
export const getOrgChildrenIdsByParentId = implementTypedPlatformFunction(getOrgChildrenIdsByParentIdFunctionDef, (context, request) => {
    return new OrgTreeHelper(context).getAllChildrenIds(request);
});
